/**
 * Чёрный список: «PEPE» — монета целиком, «PEPE@BITGET» — только связки,
 * где одна из ног на этой площадке. Канон тот же, что на сервере
 * (symbol_normalize.blacklist_entry): база без USDT и биржа заглавными.
 */
import { baseSymbol } from './symbolSearch';
import { exchangeLabel } from '../components/ExchangeIcon';
import i18n from '../i18n';

export function blEntry(raw: string): string {
  const [b, ex] = String(raw || '').trim().split('@');
  const base = baseSymbol(b || '');
  const venue = (ex || '').trim().toUpperCase();
  return base && venue ? `${base}@${venue}` : base;
}

export function blHit(bl: Set<string>, symbol: string, longEx?: string, shortEx?: string): boolean {
  if (!bl.size) return false;
  const s = (symbol || '').toUpperCase();
  const b = baseSymbol(s);
  if (bl.has(s) || bl.has(b)) return true;
  for (const ex of [longEx, shortEx]) {
    if (ex && bl.has(`${b}@${ex.toUpperCase()}`)) return true;
  }
  return false;
}

/** «PEPE@BITGET_SPOT» → «PEPE на Bitget спот». */
export function blLabel(entry: string): string {
  const [b, ex] = entry.split('@');
  return ex ? i18n.t('blacklist:label', { coin: b, venue: exchangeLabel(ex.toLowerCase()) }) : b;
}
